// Neutral link-unfurl card (og:image, domain, og:title, og:description). No platform branding.
import type { PreviewLink } from "../../../../../shared/content-preview";

export function LinkUnfurlCard({ link, compact = false }: { link: PreviewLink; compact?: boolean }) {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="preview-link-card">
      {link.image ? (
        <img src={link.image.url} alt={link.image.alt} className="aspect-[1200/630] w-full object-cover" data-testid="preview-link-image" />
      ) : (
        <div className="flex aspect-[1200/630] w-full items-center justify-center bg-slate-100 text-xs text-slate-500" data-testid="preview-link-image-missing">
          No social card yet
        </div>
      )}
      <div className={`space-y-0.5 border-t border-slate-200 bg-slate-50 ${compact ? "px-3 py-2" : "px-4 py-3"}`}>
        {link.domain && <p className="text-xs uppercase tracking-wide text-slate-500" data-testid="preview-link-domain">{link.domain}</p>}
        <p className="line-clamp-2 text-sm font-semibold text-slate-900" data-testid="preview-link-title">{link.title}</p>
        {!compact && link.description && <p className="line-clamp-2 text-xs text-slate-600" data-testid="preview-link-description">{link.description}</p>}
      </div>
    </div>
  );
}
